/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-13 18:41:51
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';

class Form1 extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      tableColumns1: [],
      tableList1: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('20_table_2').then(value => {
      const _table = Form1.parse(value);

      this.setState({
        value,
        ..._table,
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;

    const { columns, list } = parseArrayToTable(dataset, {});
    if (columns.length > 0) {
      columns[0].style = { width: 50 }
    }
    return {
      tableColumns1: columns,
      tableList1: list,
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form1.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
      </div>
    );
  }
}

export default withStyles(s)(Form1);



// WEBPACK FOOTER //
// src/routes/visualChart/P20/Form1.js